export enum ThirdEvent {
    CREATED = 'third:created',
}

export interface ThirdCreatedPayload {
    thirdid: number;
}

export interface ThirdEventMap {
    [ThirdEvent.CREATED]: ThirdCreatedPayload;
}
